import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import React, { useCallback, useContext, ReactElement } from 'react'
import LandingPageLoyaltyBenefitTile from 'loyalty/pages/loyaltyUserAccountPage/benefits/LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyStayUpgradeBenefitsModal from 'loyalty/pages/loyaltyUserAccountPage/benefits/LandingPageLoyaltyStayUpgradeBenefitsModal'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import Group from 'components/utils/Group'

const image: App.Image = {
  id: 'wfzka1j5ru5d5e7hc9u',
  title: 'Free room upgrades',
}

interface Props {
  tier: App.LoyaltyTier
  benefitLabel: ReactElement
}

function LandingPageLoyaltyStayUpgradePromoHotelUpgrade(props: Props) {
  const { tier, benefitLabel } = props
  const showModal = useContext(ModalContext)

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyStayUpgradeBenefitsModal
      image={image}
    />)
  }, [showModal])

  return <LandingPageLoyaltyBenefitTile
    heading="Upgrade your stay"
    labels={<Group direction="horizontal" gap={4}>
      {tier === 'silver' && <PromotionLabel variant="premium">New Silver benefit</PromotionLabel>}
      {tier === 'gold' && <PromotionLabel variant="premium">New benefit</PromotionLabel>}
      <LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>
    </Group>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      Details
    </TextButton>}
  >
    <BodyText variant="medium">
      Enjoy complimentary room and package upgrades at participating hotels—subject to availability—so you can travel in even more style.
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyStayUpgradePromoHotelUpgrade
